<template>
    <div ref="container">
      <a-modal :title="title" :width="800" :visible="visible" :confirmLoading="confirmLoading" :getContainer="() => $refs.container" :maskStyle="{'top':'93px','left':'154px'}" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height: 70%;">
        <template slot="footer">
          <a-button key="back" @click="handleCancel">
            关闭
          </a-button>
          <a-button type="primary" @click="handleOk">
            确认
          </a-button>
        </template>
        <a-spin :spinning="confirmLoading">
          <div class="productInfo">
            <span class="title">商品基本信息</span>
            <a-form-model ref="form" :model="form" :rules="rules">
            <a-row class="form-row">
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业名称" prop="supplierName">
                  <a-input placeholder="请输入企业名称" v-model="form.supplierName" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="编码" prop="supplierCode">
                  <a-input placeholder="请输入编码" v-model="form.supplierCode" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="法定代表人" prop="ledge">
                  <a-input placeholder="请输入法定代表人" v-model="form.ledge" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="统一社会信用代码" prop="credit">
                  <a-input placeholder="请输入统一社会信用代码" v-model="form.credit" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="注册资金(万)" prop="capital">
                  <a-input placeholder="请输入注册资金" v-model="form.capital" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申请原因" prop="reason">
                  <a-input placeholder="请输入申请原因" v-model="form.reason" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
          </div>
          
        </a-spin>
      </a-modal>
    </div>
  </template>
  <script>
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import { ledgerAdd,ledgerEdit, supplyAdd, supplyEdit } from '@/api/api'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  export default {
    name: 'VendorModal',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      JImageUpload,
    },
    // props:['productType'],
    props: {
      productType: Number
    },
    data() {
      return {
        title: '操作',
        visible: false,
        fileList: [],
        model: {},
        companyId:'',
        isReadOnly: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
        confirmLoading: false,
        form: {
          supplierName: '',
          supplierCode: '',
          ledge: '',
          credit: '',
          capital: '',
          reason: '',
        },
        uploadHeaders: {},
        action: window._CONFIG['domianURL'] + '/systemConfig/upload',
        rules: {
          supplierName: [{ required: true, message: '企业名称不能为空!' }],
          supplierCode: [{ required: true, message: '编码不能为空!' }],
          credit: [{ required: true, message: '统一社会信用代码不能为空!' }],
        },
        id: '',
      }
    },
    created() {
      console.log(this.productType,'productType===========================')
    },
    methods: {
      add() {
        this.edit({})
      },
      edit(record) {
        if (this.$refs.form !== undefined) this.$refs.form.resetFields()
        console.log(this.form, record,'form')
        this.form = record
        this.companyId = record.supplierId
        this.visible = true
        this.$nextTick(() => {})
      },
      handleChange({ file, fileList }) {
        console.log(file, 'file')
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleOk() {
        const that = this
        // 触发表单验证
        that.$refs['form'].validate(async (success) => {
          if (success === true) {
            // if (this.fileList.length == 0) return this.$message.warning('请上传至少一张图片')
            let params = {
              supplierName: this.form.supplierName || '',
              supplierCode: this.form.supplierCode || '',
              ledge: this.form.ledge || '',
              credit: this.form.credit || '',
              capital: this.form.capital || '',
              reason: this.form.reason || '',
              type: this.productType
            }
            if (this.companyId) {
              // 编辑
              params.supplierId = this.companyId
              const res = await supplyEdit(params)
              console.log(res, 'res')
              if (res.code == 200 && res.success == true) {
                this.$message.success(res.message)
                this.$refs.form.resetFields();
                this.close()
              } else {
                this.$message.error(res.data || res.errmsg)
              }
            } else {
              const res = await supplyAdd(params)
              console.log(res, 'res')
              if (res.code == 200 && res.success == true) {
                this.$message.success(res.message)
                this.$refs.form.resetFields();
                this.close()
              } else {
                this.$message.error(res.message)
              }
            }
          }
        })
      },
      handleCancel() {
        this.close()
      },
      validateSupplierName(rule, value, callback) {
        let params = {
          name: value,
          type: '供应商',
          id: this.model.id ? this.model.id : 0,
        }
        checkSupplier(params).then((res) => {
          if (res && res.code === 200) {
            if (!res.data.status) {
              callback()
            } else {
              callback('名称已经存在')
            }
          } else {
            callback(res.data)
          }
        })
      },
    },
  }
  </script>
  <style scoped>
    .productInfo {
      border: 1px solid #dedede;
      padding: 10px;  
    }
    .productInfo .title {
      font-size: 16px;
      border-left: 4px solid #1890FE;
      padding-left: 10px;
      margin: 0 10px;
    }
  </style>